<template>
<b-row class="ot-main-panel no-gutters">
    <b-col v-if="loaded === false">
        <template>
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
    </b-col>
    <b-col v-else>
        <b-row>
             <ECMErrorDialog ref="messageDlg" v-model="messageDlg"/>
        </b-row>
        <b-row>
            <b-col >
                <otif-ecm-table-info
                    ref="table"
                    :sortCallback="sort"
                    :totalRowsCallback="totalRows"
                    :rows="warnings"
                    :columns="columns"
                    :paginated="true"
                    :pageSizeCallback="setPageSize"
                    :selectPageCallback="selectPage"
                    :currentPageCallback="currentPage"
                    @pageSize="setPageSize">
                    <template slot="empty">
                       {{ecmResourceStrings.msgNoInfo}}
                    </template>
                </otif-ecm-table-info>
            </b-col>
        </b-row>
    </b-col>
</b-row>
</template>

<script>

import ecmRepositoryDefinition from '@/ecm/collections/ecmrepodefinitions.js';
import { sortOn } from '../../../utils/commonECM.js';
import axios from 'axios';
import MessageColumn from '../../links/executionwarnings.vue';
import { showMessage} from '../../../utils/commonECM.js';
import ECMErrorDialog from '../../modals/ECMCrawlerMessageDlg.vue';
import { getguivalue } from '../../../utils/commonECM.js';
import Collection from '@/collections/basic.js';

export default {

    props: ['ecmrepositoryid','ecmrepositoryname','ecmrepositorytype'],
 
    data() {
        return {
            ecmResourceStrings: require('../../../utils/resourceECM.js'),  
            collection: new Collection({paginated: true}),
            messageDlg:false,
            ExecStatusData : null,
            columns: [
            {
                name: 'name',
                label: 'Partition Description',
                sortable: true,
                editable:false,
                render(row) {
                    return row.name;
                }
            },{
                name: 'status',
                label: 'Status',
                sortable: true,
                editable:false,
                render(row) {
                    return row.status;
                }
            },{
                name: 'statusDate',
                label: 'Status date',
                sortable: true,
                editable:false,
                render(row) {
                    return row.statusDate;
                }
            }],
            loaded: false
        }
    },

    computed: {
         warnings() {
            return this.collection.resources;
        }
    },

    methods: {
        refresh(){
            this.loaded = true;
        },

        sort(colNumber, dir) {
            const fieldName = this.columns[colNumber].name;
            this.collection.resources.sort(sortOn(fieldName, dir));
        },

        totalRows() {
            return this.collection.resources.length;
        },

        setPageSize(pageSize) {
            this.collection.setPageSize(pageSize);
            this.collection.selectPage(0);
        },

        selectPage(page) {
            this.$refs['table'].currentPage = page;
            this.current_page = page;
        },

        currentPage() {
            return this.collection.current_page;
        },

        showFullMessage(row){
            var that = this;
            if(row.message)
            {
                showMessage(this, 'info', that.ecmResourceStrings.ttlWarnings,'', true, row.message);
            }
        },
    },

    components: {
        ECMErrorDialog
    },
    
     mounted() {
        if(this.ecmrepositorytype == "dbms_generic_v1")
        {
            var breadcrumbs = [{
                name: 'reports',
                meta: { label: 'Reports' }
            },{
                name: 'rdbms-reports',
                meta: { label: 'RDBMS Crawler Reports' }
            },{
                name: 'rdbms-reports-details',
                meta: { label: 'RDBMS Crawler Reports Details' }
            },{
                name: 'reports-exec-rdbms',
                meta: { label: 'Last Execution Status' }
            }];

            this.$store.commit('breadcrumbs', breadcrumbs);
        }
        else
        {
            var breadcrumbs = [{
                name: 'reports',
                meta: { label: 'Reports' }
            },{
                name: 'ecm-reports',
                meta: { label: 'ECM Crawler Reports' }
            },{
                name: 'reports-exec',
                meta: { label: 'Last Execution Status' }
            }];

            this.$store.commit('breadcrumbs', breadcrumbs);
        }
    },
   
    created() {
        var that = this;
        that.ExecStatusData=[];
        if(that.collection.resources)
        {
            while(that.collection.resources.length > 0) {that.collection.resources.pop();}
        }
    
        axios.get('/mtm-gateway-api/v1/services/ecm/ECMRepositories/'+ that.ecmrepositoryid)
        .then((res) => {
            this.$snotify.clear();
            if (res.data) {
                //partitions and connections come from repositories
                //ECMRepositoriesStatusListView line 90
                const parameters = res.data.configData;
                if(parameters)
                {
                    const len = parameters.length;
                    if(len!=0)
                    {
                        for(var i=0; i<len; i++)
                        {
                            const oneelement = parameters[i];
                            if(oneelement)
                            {
                                const paramfullName = oneelement.name;
                                var paramIndex = 0;//for partitions
                                var paramName = '';
                                //parse name to see what we have
                                //could be one word
                                //repoParam.0.hostName, repoPartitionTask.0.folderPathOrId, repoExcludedFolder.1.folderPathOrId
                                const namesArray = paramfullName.split(".");
                                const lennames = namesArray.length;
                                if(lennames > 1)
                                {
                                    if (namesArray[0] == "repoPartition")
                                    {
                                    paramIndex = namesArray[1]; 
                                    paramName = namesArray[2]; 
                                    
                                    var result = that.ExecStatusData.filter((el) => (el.index == paramIndex));
                                    if (result && result.length == 0)
                                    {
                                        // not found - add
                                        that.ExecStatusData.push({"index" : paramIndex, "description" : '', "status": '', "statusDate" : ''});
                                        //get it
                                        var resultnew = that.ExecStatusData.filter((el) => (el.index == paramIndex));
                                        
                                        if (resultnew && resultnew.length == 1)
                                        {
                                            if(paramName == 'description')
                                            {
                                                resultnew[0].description = oneelement.value;
                                            }
                                            if(paramName == 'status')
                                            {
                                                const data = getguivalue('partitionstatus', oneelement.value);
                                                                            
                                                resultnew[0].status = data;
                                            }
                                            if(paramName == 'statusDate')
                                            {
                                                if(oneelement.value != null)
                                                {
                                                    var originaldate = oneelement.value;
                                                                                    
                                                    const d = new Date(originaldate);
                                                                                    
                                                    if(d == "Invalid Date")
                                                    {
                                                        originaldate = originaldate.toLocaleString();
                                                    }
                                                    else
                                                    {
                                                        originaldate = d.toLocaleString();
                                                    }
                                                                                    
                                                    resultnew[0].statusDate = originaldate; 
                                                }

                                            }
                                        }
                                    }
                                    else if (result && result.length == 1)
                                    {
                                        if(paramName == 'description')
                                        {
                                            result[0].description = oneelement.value;
                                        }
                                        if(paramName == 'status')
                                        {
                                            const data = getguivalue('partitionstatus', oneelement.value);
                                                                    
                                            result[0].status = data;
                                        }
                                        if(paramName == 'statusDate')
                                        {
                                            if(oneelement.value != null)
                                            {
                                                var originaldate = oneelement.value;
                                                                            
                                                const d = new Date(originaldate);
                                                                            
                                                if(d == "Invalid Date")
                                                {
                                                    originaldate = originaldate.toLocaleString();
                                                }
                                                else
                                                {
                                                    originaldate = d.toLocaleString();
                                                }
                                                //var partsArray = originaldate.split(',');
                                                                            
                                                result[0].statusDate = originaldate;
                                            }
                                        }
                                    } 
                                }
                            }
                        }
                    }
            
                    for (var cnt = 0; cnt < that.ExecStatusData.length; cnt++)
                    {
                         this.collection.resources.push({"name" : that.ExecStatusData[cnt].description, "id" : that.ExecStatusData[cnt].index, "status" : that.ExecStatusData[cnt].status, "statusDate" : that.ExecStatusData[cnt].statusDate});
                    }
                }
            }
            this.loaded = true;
        }})
        .catch((err) => {
            this.$snotify.clear();
            if(err.message)
            {
                this.$snotify.error(err.message, this.ecmResourceStrings.txtError);
            }
            else  if(err.response)
            {
                this.$snotify.error(err.response.data, this.ecmResourceStrings.txtError);
            }
            this.loaded = true;
        });
        return;    
    },
}

</script>
